exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".TabNav-35d08209{display:flex;font-size:14px;background:#ebebeb}.Tab-8a7ce8ae{flex:1;text-align:center;cursor:pointer;padding:10px 15px;border-right:1px solid #bbb;border-bottom:1px solid #bbb}.Tab-8a7ce8ae:last-child{border-right:none}.activeTab-7bd4582c{font-weight:bold;background:#f7f7f7;border-bottom:3px solid #f70}\n", ""]);

// Exports
exports.locals = {
	"TabNav": "TabNav-35d08209",
	"Tab": "Tab-8a7ce8ae",
	"activeTab": "activeTab-7bd4582c"
};